var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { authService } from '../services/auth-service';
let JvLogin = class JvLogin extends LitElement {
    constructor() {
        super(...arguments);
        this._email = '';
        this._password = '';
        this._tenantId = '';
        this._error = '';
        this._submitting = false;
    }
    static { this.styles = css `
    :host {
      display: block;
      min-height: 100vh;
    }
  `; }
    async _handleSubmit(e) {
        e.preventDefault();
        this._error = '';
        if (!this._email || !this._password || !this._tenantId) {
            this._error = 'All fields are required.';
            return;
        }
        this._submitting = true;
        try {
            await authService.login(this._email, this._password, this._tenantId);
            const profile = await authService.getProfile();
            this.dispatchEvent(new CustomEvent('login-success', {
                detail: profile,
                bubbles: true,
                composed: true,
            }));
        }
        catch (err) {
            const apiErr = err;
            this._error = apiErr?.message ?? apiErr?.error ?? 'Invalid credentials. Please try again.';
        }
        finally {
            this._submitting = false;
        }
    }
    render() {
        return html `
      <main class="min-h-screen grid place-items-center px-4 py-10">
        <div class="w-full max-w-sm">
          <div class="text-center mb-7">
            <span class="inline-flex items-center gap-2">
              <span class="grid place-items-center w-11 h-11 rounded-2xl bg-jv-primary text-white shadow-jv">
                <svg viewBox="0 0 24 24" class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>
              </span>
              <span class="font-extrabold text-jv-ink text-2xl tracking-tight">Just<span class="text-jv-primary">Vue</span></span>
            </span>
            <p class="text-sm text-jv-ink-2 mt-4">See your child's classroom, live.</p>
          </div>

          <section class="jv-card">
            <div class="p-6 sm:p-7">
              <div class="mb-5">
                <h1 class="text-xl font-extrabold tracking-tight text-jv-ink">Sign in to watch</h1>
                <p class="text-sm text-jv-ink-2 mt-1">Welcome back. Your cameras are ready when you are.</p>
              </div>

              ${this._error ? html `
                <div class="mb-5 p-3 rounded-xl bg-jv-danger-050 text-jv-danger text-sm font-medium">
                  ${this._error}
                </div>
              ` : ''}

              <form @submit=${this._handleSubmit} class="space-y-4">
                <div>
                  <label class="jv-label" for="tenantId">School ID</label>
                  <input class="jv-input" id="tenantId" type="text"
                         .value=${this._tenantId}
                         @input=${(e) => this._tenantId = e.target.value}
                         placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
                </div>

                <div>
                  <label class="jv-label" for="email">Email</label>
                  <input class="jv-input" id="email" type="email" inputmode="email" autocomplete="email"
                         .value=${this._email}
                         @input=${(e) => this._email = e.target.value}
                         placeholder="you@example.com" />
                </div>

                <div>
                  <label class="jv-label" for="password">Password</label>
                  <input class="jv-input" id="password" type="password" autocomplete="current-password"
                         .value=${this._password}
                         @input=${(e) => this._password = e.target.value}
                         placeholder="Your password" />
                </div>

                <button type="submit"
                        ?disabled=${this._submitting}
                        class="w-full jv-btn-primary">
                  ${this._submitting
            ? 'Signing in…'
            : html `<svg viewBox="0 0 24 24" class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg> Sign in`}
                </button>
              </form>

              <div class="mt-5 pt-5 border-t border-jv-border flex items-start gap-2.5">
                <svg viewBox="0 0 24 24" class="w-[18px] h-[18px] text-jv-primary mt-0.5 shrink-0" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                <p class="text-xs text-jv-ink-2 leading-relaxed">
                  Cameras are only viewable during your school's operating hours, and every session is recorded
                  in the audit log. These limits are set by your school and enforced on our servers.
                </p>
              </div>
            </div>
          </section>

          <p class="text-center text-sm text-jv-ink-2 mt-6">
            Need access? Ask your school to send you an invite.
          </p>
        </div>
      </main>
    `;
    }
};
__decorate([
    state()
], JvLogin.prototype, "_email", void 0);
__decorate([
    state()
], JvLogin.prototype, "_password", void 0);
__decorate([
    state()
], JvLogin.prototype, "_tenantId", void 0);
__decorate([
    state()
], JvLogin.prototype, "_error", void 0);
__decorate([
    state()
], JvLogin.prototype, "_submitting", void 0);
JvLogin = __decorate([
    customElement('jv-login')
], JvLogin);
export { JvLogin };
